<form [formGroup]="formGroup">
    <ng-container *ngFor="let setting of settingsConfig">
        <ng-container *ngLet="formGroup.get(setting.key) as field"
                      [ngSwitch]="setting.valueType">
            <mat-form-field>

                <ng-container *ngSwitchCase="ValueTypes.multipleChoice">
                    <ui-suggest [clearable]="false"
                                [formControlName]="setting.key"
                                [placeholder]="'ExecutionSettings_' + setting.key | translate"
                                [items]="dropdownEntries[setting.key]">
                    </ui-suggest>
                </ng-container>

                <ng-container *ngSwitchCase="ValueTypes.integer">
                    <input [formControlName]="setting.key"
                           [max]="maxIntegerValue"
                           [placeholder]="'ExecutionSettings_' + setting.key | translate"
                           required
                           matInput
                           min="0"
                           uiRestrictInput="^[0-9]+$" />
                    <mat-error *ngIf="field.hasError('range')"
                               [translateParams]="{
                                    min: field.getError('range').min,
                                    max: field.getError('range').max
                               }"
                               translate>
                        ExecutionSettings_range_warning
                    </mat-error>

                </ng-container>

                <ng-container *ngSwitchCase="ValueTypes.boolean">
                    <ui-toggle-switch [formControlName]="setting.key"
                                      [placeholder]="'ExecutionSettings_' + setting.key | translate"
                                      [onString]="'ToggleBoolean_Yes' | translate"
                                      [offString]="'ToggleBoolean_No' | translate">
                    </ui-toggle-switch>
                </ng-container>

                <mat-slide-toggle #toggle
                                  [checked]="field.enabled || (disabled && formGroup.previouslyEnabledKeys.includes(setting.key))"
                                  [disabled]="disabled"
                                  (change)="onSettingToggle($event, setting.key)"
                                  (click)="$event.stopImmediatePropagation()"
                                  matSuffix>
                </mat-slide-toggle>
            </mat-form-field>

        </ng-container>
    </ng-container>
</form>
